import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FeaturesConfigModule, I18nModule, OccProductSearchAdapter, UrlModule, provideDefaultConfig } from "@spartacus/core";
import { OutletModule, IconModule, ItemCounterModule, AtMessageModule, ListNavigationModule, MediaModule, PageComponentModule, ProductListModule, SpinnerModule, StarRatingModule} from "@spartacus/storefront";

import { RouterModule } from "@angular/router";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { KbAddToCartModule } from "../../kb-add-to-cart/kb-add-to-cart.module";
import { KbCrossRefGridItemComponent } from "./kb-cross-ref-grid-item.component";
import { compareCheckBoxModule } from "../check-box-compare/compareCheckBox.module";
import { KbPipesModule } from "src/app/pipes/kb-pipes.module";

@NgModule({
 imports:[
    AtMessageModule,
    CommonModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,
    KbAddToCartModule,
    compareCheckBoxModule,
    KbPipesModule
 ],
 providers: [OccProductSearchAdapter
  ],
  exports:[KbCrossRefGridItemComponent],
 declarations:[KbCrossRefGridItemComponent]
})
export class KbCrossRefGridItemModule {

}
